// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  padding: 0 12px;
  --background: #fff;
}
ion-toolbar ion-icon {
  height: 22px;
  width: 22px;
}
ion-toolbar ion-title {
  font-family: AppFontSemiBold;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.44px;
  text-align: left;
  color: #785526;
}
ion-toolbar ion-icon {
  color: #785526;
  fill: #785526;
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-toolbar/account-toolbar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;AACF;AAAE;EACE,YAAA;EACA,WAAA;AAEJ;AAAE;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAEJ;AACE;EACE,cAAA;EACA,aAAA;AACJ","sourcesContent":["ion-toolbar {\n  padding: 0 12px;\n  --background: #fff;\n  ion-icon {\n    height: 22px;\n    width: 22px;\n  }\n  ion-title {\n    font-family: AppFontSemiBold;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19.44px;\n    text-align: left;\n    color: #785526;\n  }\n\n  ion-icon {\n    color: #785526;\n    fill: #785526;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
